import { render, staticRenderFns } from "./ChatbotPage.vue?vue&type=template&id=e8c7b7fa"
import script from "./ChatbotPage.vue?vue&type=script&lang=js"
export * from "./ChatbotPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports